
import { defaultCircle, getTextWidthInPixels, makePath, Path, defaultPath, makeAnyPath, defaultPolygon, cornerCircle, Polygon, makePolygon, Line, makeLine, portCircleTarget, Circle, portCircle, makeCircle, Text$, defaultText, makeText } from "../Common/DrawHelpers.js";
import { max, fold2, last, map as map_2, cons, reverse, exists, fold as fold_1, toArray, append, item as item_1, map2, collect, empty, length, ofArray, singleton } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { head, fold, map as map_1, item, equalsWith } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { int32ToString, comparePrimitives, compare, equals, defaultOf } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { Constants_testShowLabelBoundingBoxes, Constants_labelCorrection, Constants_componentLabelOffsetDistance, Constants_thinComponentLabelOffsetDistance, getComponentLegend, Constants_legendVertOffset, Constants_otherLegendFontSizeInPixels, Constants_arrayLegendFontSizeInPixels, Constants_customLegendFontSizeInPixels, busTitleAndBits, Constants_busSelectTextSize, busSelectTitle, Constants_mergeSplitTextSize, getPortPos, Constants_componentPortStyle, Constants_componentLabelStyle, Constants_legendLineSpacingInPixels } from "./Symbol.js";
import { concat, toText, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { $007CIsBinaryGate$007CNotBinaryGate$007C, Edge, Rotation, PortType, XYPos } from "../Common/CommonTypes.js";
import { empty as empty_1, filter, toList as toList_1, tryFind, FSharpMap__get_Item } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { DrawModelType_SymbolT_Model, DrawModelType_SymbolT_ThemeType, DrawModelType_HighlightedModule_compColour, DrawModelType_SymbolT_appearance_, DrawModelType_SymbolT_colour_, DrawModelType_SymbolT_ThemeType_$reflection, DrawModelType_SymbolT_Msg_$reflection, DrawModelType_SymbolT_Symbol_$reflection, DrawModelType_SymbolT_ShowPorts } from "../Model/DrawModelType.js";
import { getCustomSymCorners } from "./SymbolHelpers.js";
import { value as value_5, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { fillHexBignum } from "../Simulator/NumberHelpers.js";
import { portNames } from "../Simulator/CanvasStateAnalyser.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type, string_type, lambda_type, unit_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { Helpers_equalsButFunctions } from "../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { empty as empty_2, contains } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

/**
 * Text adding function with many parameters (such as bold, position and text)
 */
export function addText(pos, name, alignment, weight, size) {
    return singleton(makeText(pos.X, pos.Y, name, new Text$(alignment, size, weight, defaultText.FontFamily, defaultText.Fill, defaultText.UserSelect, defaultText.DominantBaseline)));
}

/**
 * Text adding function using text record
 */
export function addStyledText(pos, text, name) {
    return makeText(pos.X, pos.Y, name, text);
}

/**
 * Add one or two lines of text, two lines are marked by a . delimiter
 */
export function addLegendText(pos, name, alignment, weight, size) {
    const textStyle = new Text$(alignment, size, weight, defaultText.FontFamily, defaultText.Fill, defaultText.UserSelect, defaultText.DominantBaseline);
    const matchValue = name.split(".");
    if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 1)) {
        item(0, matchValue);
        return singleton(makeText(pos.X, pos.Y, name, textStyle));
    }
    else if (!equalsWith((x_1, y_1) => (x_1 === y_1), matchValue, defaultOf()) && (matchValue.length === 2)) {
        const topLine = item(0, matchValue);
        const bottomLine = item(1, matchValue);
        return ofArray([makeText(pos.X, pos.Y, topLine, textStyle), makeText(pos.X, pos.Y + Constants_legendLineSpacingInPixels, bottomLine, textStyle)]);
    }
    else {
        return toFail(printf("addLegendText does not work with more than two lines demarcated by ."));
    }
}

function portText(pos, name, edge) {
    let left_1, right_1, left_2, right_2, left_3, right_3, left, right;
    return addText((edge.tag === 0) ? ((left_1 = pos, (right_1 = (new XYPos(0, 5)), new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y)))) : ((edge.tag === 3) ? ((left_2 = pos, (right_2 = (new XYPos(-5, -6)), new XYPos(left_2.X + right_2.X, left_2.Y + right_2.Y)))) : ((edge.tag === 1) ? ((left_3 = pos, (right_3 = (new XYPos(0, -15)), new XYPos(left_3.X + right_3.X, left_3.Y + right_3.Y)))) : ((left = pos, (right = (new XYPos(5, -6)), new XYPos(left.X + right.X, left.Y + right.Y)))))), name, (edge.tag === 3) ? "end" : ((edge.tag === 2) ? "start" : "middle"), Constants_componentLabelStyle.FontWeight, Constants_componentPortStyle.FontSize);
}

/**
 * Print the name of each port
 */
export function drawPortsText(portList, listOfNames, symb) {
    if (length(listOfNames) < 1) {
        return empty();
    }
    else {
        return collect((x_1) => x_1, map2((name, x) => {
            let sym, port, matchValue, movingPort_1, left, right;
            return portText((sym = symb, (port = item_1(x, portList), (matchValue = sym.MovingPort, (matchValue != null) ? (equals(port.Id, matchValue.PortId) ? ((movingPort_1 = matchValue, (left = movingPort_1.CurrPos, (right = sym.Pos, new XYPos(left.X - right.X, left.Y - right.Y))))) : getPortPos(sym, port)) : getPortPos(sym, port)))), name, FSharpMap__get_Item(symb.PortMaps.Orientation, item_1(x, portList).Id));
        }, listOfNames, toList(rangeDouble(0, 1, length(portList) - 1))));
    }
}

/**
 * Function to draw ports using getPortPos. The ports are equidistant
 */
export function drawPorts(portType, portList, showPorts, symb) {
    if (!(length(portList) < 1)) {
        let matchResult, p;
        switch (showPorts.tag) {
            case 2:
            case 3: {
                matchResult = 0;
                break;
            }
            case 0: {
                if (portType.tag === 0) {
                    matchResult = 0;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case 1: {
                if (portType.tag === 1) {
                    matchResult = 0;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case 5: {
                matchResult = 1;
                p = showPorts.fields[0];
                break;
            }
            case 6: {
                matchResult = 1;
                p = showPorts.fields[0];
                break;
            }
            default:
                matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return collect((x) => {
                    let pos;
                    const sym = symb;
                    const port = item_1(x, portList);
                    const matchValue_1 = sym.MovingPort;
                    let matchResult_1, movingPort_1;
                    if (matchValue_1 != null) {
                        if (equals(port.Id, matchValue_1.PortId)) {
                            matchResult_1 = 0;
                            movingPort_1 = matchValue_1;
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    switch (matchResult_1) {
                        case 0: {
                            const left = movingPort_1.CurrPos;
                            const right = sym.Pos;
                            pos = (new XYPos(left.X - right.X, left.Y - right.Y));
                            break;
                        }
                        default:
                            pos = getPortPos(sym, port);
                    }
                    const show = showPorts;
                    return singleton(makeCircle(pos.X, pos.Y, (show.tag === 3) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show.tag === 5) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show.tag === 6) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "Red")) : ((show.tag === 7) ? portCircleTarget : portCircle)))));
                }, toList(rangeDouble(0, 1, length(portList) - 1)));
            case 1:
                return collect((x_1) => {
                    if (equals(item_1(x_1, portList), p)) {
                        let pos_1;
                        const sym_1 = symb;
                        const port_1 = item_1(x_1, portList);
                        const matchValue_2 = sym_1.MovingPort;
                        let matchResult_2, movingPort_1_1;
                        if (matchValue_2 != null) {
                            if (equals(port_1.Id, matchValue_2.PortId)) {
                                matchResult_2 = 0;
                                movingPort_1_1 = matchValue_2;
                            }
                            else {
                                matchResult_2 = 1;
                            }
                        }
                        else {
                            matchResult_2 = 1;
                        }
                        switch (matchResult_2) {
                            case 0: {
                                const left_1 = movingPort_1_1.CurrPos;
                                const right_1 = sym_1.Pos;
                                pos_1 = (new XYPos(left_1.X - right_1.X, left_1.Y - right_1.Y));
                                break;
                            }
                            default:
                                pos_1 = getPortPos(sym_1, port_1);
                        }
                        const show_1 = showPorts;
                        return singleton(makeCircle(pos_1.X, pos_1.Y, (show_1.tag === 3) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show_1.tag === 5) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show_1.tag === 6) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "Red")) : ((show_1.tag === 7) ? portCircleTarget : portCircle)))));
                    }
                    else {
                        let pos_2;
                        const sym_2 = symb;
                        const port_2 = item_1(x_1, portList);
                        const matchValue_3 = sym_2.MovingPort;
                        let matchResult_3, movingPort_1_2;
                        if (matchValue_3 != null) {
                            if (equals(port_2.Id, matchValue_3.PortId)) {
                                matchResult_3 = 0;
                                movingPort_1_2 = matchValue_3;
                            }
                            else {
                                matchResult_3 = 1;
                            }
                        }
                        else {
                            matchResult_3 = 1;
                        }
                        switch (matchResult_3) {
                            case 0: {
                                const left_2 = movingPort_1_2.CurrPos;
                                const right_2 = sym_2.Pos;
                                pos_2 = (new XYPos(left_2.X - right_2.X, left_2.Y - right_2.Y));
                                break;
                            }
                            default:
                                pos_2 = getPortPos(sym_2, port_2);
                        }
                        const show_2 = DrawModelType_SymbolT_ShowPorts.ShowBothForPortMovement;
                        return singleton(makeCircle(pos_2.X, pos_2.Y, (show_2.tag === 3) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show_2.tag === 5) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show_2.tag === 6) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "Red")) : ((show_2.tag === 7) ? portCircleTarget : portCircle)))));
                    }
                }, toList(rangeDouble(0, 1, length(portList) - 1)));
            default:
                return empty();
        }
    }
    else {
        return empty();
    }
}

/**
 * Function to draw the Target of a Moving Port (if there is one)
 */
export function drawMovingPortTarget(pos, symbol, outlinePoints) {
    if (pos != null) {
        const targetPos = pos[0];
        const mousePos = pos[1];
        let list_3;
        let list_1;
        const pos_1 = targetPos;
        const show = DrawModelType_SymbolT_ShowPorts.ShowTarget;
        list_1 = singleton(makeCircle(pos_1.X, pos_1.Y, (show.tag === 3) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show.tag === 5) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "DodgerBlue")) : ((show.tag === 6) ? (new Circle(portCircle.R, portCircle.Stroke, portCircle.StrokeWidth, portCircle.FillOpacity, "Red")) : ((show.tag === 7) ? portCircleTarget : portCircle)))));
        list_3 = append(singleton(makeLine(targetPos.X, targetPos.Y, mousePos.X - symbol.Pos.X, mousePos.Y - symbol.Pos.Y, new Line("DodgerBlue", "2.0px", "4,4"))), list_1);
        return append(singleton(makePolygon(outlinePoints, new Polygon("DodgerBlue", "2px", 0, "No"))), list_3);
    }
    else {
        return empty();
    }
}

/**
 * HLP23 AUTHOR: BRYAN TAN
 * Draw circles on the corners of custom components when manually resizing them
 */
export function drawCorners(showCorners, symb) {
    if (showCorners.tag === 0) {
        return ofArray(map_1((p) => makeCircle(p.X, p.Y, cornerCircle), getCustomSymCorners(symb)));
    }
    else {
        return empty();
    }
}

export function createPolygon(points, colour, opacity) {
    return singleton(makePolygon(points, new Polygon(defaultPolygon.Stroke, defaultPolygon.StrokeWidth, opacity, colour)));
}

export function createAnyPath(startingPoint, pathAttr, colour, strokeWidth, outlineColour) {
    return singleton(makeAnyPath(startingPoint, pathAttr, new Path(outlineColour, strokeWidth, defaultPath.StrokeDashArray, defaultPath.StrokeLinecap, colour)));
}

export function createPath(startingPoint, startingControlPoint, endingControlPoint, endingPoint) {
    return singleton(makePath(startingPoint, startingControlPoint, endingControlPoint, endingPoint, new Path("black", "5px", defaultPath.StrokeDashArray, defaultPath.StrokeLinecap, defaultPath.Fill)));
}

export function createBiColorPolygon(points, colour, strokeColor, opacity, strokeWidth, comp) {
    if (strokeColor !== "black") {
        return singleton(makePolygon(points, new Polygon(strokeColor, strokeWidth, opacity, colour)));
    }
    else {
        return singleton(makePolygon(points, new Polygon(defaultPolygon.Stroke, strokeWidth, opacity, colour)));
    }
}

export function addClock(pos, colour, opacity) {
    let left, right;
    const list_1 = createPolygon(toText(`${pos.X},${pos.Y - 1},${pos.X + 8},${pos.Y - 7},${pos.X},${pos.Y - 13}`), colour, opacity);
    return append(addText((left = pos, (right = (new XYPos(10, -13)), new XYPos(left.X + right.X, left.Y + right.Y))), " clk", "start", "normal", "12px"), list_1);
}

export function addHorizontalLine(posX1, posX2, posY, opacity) {
    return createPolygon(toText(`${posX1},${posY},${posX2},${posY}`), "lightgray", opacity);
}

export function outlineColor(color) {
    const matchValue = color.toLocaleLowerCase();
    switch (matchValue) {
        case "lightgray":
        case "lightblue":
        case "#E8D0A9":
        case "rgba(255,255,0,0.15)":
            return "black";
        default:
            return matchValue;
    }
}

export function addHorizontalColorLine(posX1, posX2, posY, opacity, color) {
    return singleton(makePolygon(toText(`${posX1},${posY} ${posX2},${posY}`), new Polygon(outlineColor(color), "2.0", opacity, "olcolor")));
}

/**
 * Takes points, height and width of original shape and returns the points for it given a rotation / flipped status.
 * Degree0 rotation has TopLeft = top left coordinate of the outline, which is a box of dimensions W X H.
 * Rotation rotates the box about its centre point, keeping TopLeft fixed.
 */
export function rotatePoints(points, centre, transform) {
    let pts, pointsIn, matchValue_1;
    let offset;
    const matchValue = transform.Rotation;
    switch (matchValue.tag) {
        case 1:
        case 3: {
            offset = (new XYPos(centre.Y, centre.X));
            break;
        }
        default:
            offset = centre;
    }
    return map_1((x_1) => {
        const left_1 = x_1;
        const right_1 = offset;
        return new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y);
    }, (pts = ((pointsIn = map_1((x) => {
        const left = x;
        const right = centre;
        return new XYPos(left.X - right.X, left.Y - right.Y);
    }, points), (matchValue_1 = transform.Rotation, (matchValue_1.tag === 3) ? map_1((pos) => (new XYPos(-pos.Y, pos.X)), pointsIn) : ((matchValue_1.tag === 2) ? map_1((pos_1) => (new XYPos(-pos_1.X, -pos_1.Y)), pointsIn) : ((matchValue_1.tag === 1) ? map_1((pos_2) => (new XYPos(pos_2.Y, -pos_2.X)), pointsIn) : pointsIn))))), !transform.flipped ? pts : map_1((point) => (new XYPos(-point.X, point.Y)), pts)));
}

/**
 * Draw symbol (and its label) using theme for colors, returning a list of React components
 * implementing all of the text and shapes needed.
 */
export function drawComponent(symbol, theme) {
    let matchValue_13, gateType, list_14, list_12, list_10, list_8, list_4, tupledArg_1, compWidth, symbol_1, vertFlip, getNum, offset, matchValue_39, matchValue_40, matchValue_41, chevronShift, matchValue_43, left_17, left_16, right_16, right_17, comp_2, box, margin, matchValue_29, pos_13, left_10, left_9, left_8, right_8, right_9, text_2, matchValue_31, loop, dimW, dimH, left_11, right_11, left_12, right_12, left_14, left_13, right_13, right_14, y_3, x_8, w_1, h_1;
    const appear = symbol.Appearance;
    const colour = appear.Colour;
    const showPorts = appear.ShowPorts;
    const comp = symbol.Component;
    let patternInput_1;
    const sym = symbol;
    const comp_1 = sym.Component;
    const matchValue = defaultArg(sym.HScale, 1);
    const vS = defaultArg(sym.VScale, 1);
    const hS = matchValue;
    const matchValue_2 = sym.STransform.Rotation;
    switch (matchValue_2.tag) {
        case 1:
        case 3: {
            patternInput_1 = [comp_1.W * hS, comp_1.H * vS];
            break;
        }
        default:
            patternInput_1 = [comp_1.H * vS, comp_1.W * hS];
    }
    const w = patternInput_1[1];
    const h = patternInput_1[0];
    const H = comp.H * defaultArg(symbol.VScale, 1);
    const W = comp.W * defaultArg(symbol.HScale, 1);
    const transform_1 = symbol.STransform;
    const mergeSplitLine = (pos, msb, lsb) => {
        let matchValue_3, matchValue_4;
        return addText(pos, (matchValue_3 = equals(msb, lsb), (matchValue_4 = (compare(msb, lsb) >= 0), matchValue_4 ? (matchValue_3 ? toText(`(${msb})`) : toText(`(${msb}:${lsb})`)) : "")), "middle", "bold", Constants_mergeSplitTextSize);
    };
    const mergeSplitNLine = (compType, portType, pos_1, msb_1, lsb_1) => {
        let left_1, right_1, left, right, left_3, right_3, left_2, right_2;
        let text_1;
        const matchValue_6 = equals(msb_1, lsb_1);
        const matchValue_7 = compare(msb_1, lsb_1) >= 0;
        text_1 = (matchValue_7 ? (matchValue_6 ? toText(`(${msb_1})`) : toText(`(${msb_1}:${lsb_1})`)) : "");
        const textMeasureWidth = getTextWidthInPixels;
        const textStyle = new Text$("middle", Constants_mergeSplitTextSize, "bold", defaultText.FontFamily, defaultText.Fill, defaultText.UserSelect, defaultText.DominantBaseline);
        return addText((compType.tag === 29) ? ((portType.tag === 1) ? ((left_1 = pos_1, (right_1 = (new XYPos(textMeasureWidth(textStyle, text_1) / 2, 4)), new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y)))) : ((left = pos_1, (right = (new XYPos(textMeasureWidth(textStyle, text_1) / 2, -4)), new XYPos(left.X - right.X, left.Y - right.Y))))) : ((compType.tag === 30) ? ((portType.tag === 1) ? ((left_3 = pos_1, (right_3 = (new XYPos(textMeasureWidth(textStyle, text_1) / 2, 5)), new XYPos(left_3.X - right_3.X, left_3.Y - right_3.Y)))) : ((left_2 = pos_1, (right_2 = (new XYPos(textMeasureWidth(textStyle, text_1) / 2, -4)), new XYPos(left_2.X - right_2.X, left_2.Y - right_2.Y))))) : pos_1), text_1, "middle", "bold", Constants_mergeSplitTextSize);
    };
    let clockTxtPos;
    const matchValue_10 = transform_1.Rotation;
    const matchValue_11 = transform_1.flipped;
    clockTxtPos = ((matchValue_10.tag === 2) ? (matchValue_11 ? (new XYPos(17, 2)) : (new XYPos(W - 19, 2))) : ((matchValue_10.tag === 1) ? (matchValue_11 ? (new XYPos(8, h - 20)) : (new XYPos(w - 8, h - 20))) : ((matchValue_10.tag === 3) ? (matchValue_11 ? (new XYPos(w - 10, 11)) : (new XYPos(10, 11))) : (matchValue_11 ? (new XYPos(W - 17, H - 13)) : (new XYPos(17, H - 13))))));
    const points = fold((x, pos_3) => (x + toText(` ${pos_3.X},${pos_3.Y}`)), "", rotatePoints((matchValue_13 = comp.Type, (matchValue_13.tag === 48) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos((W * 4) / 5, H), new XYPos(W, H / 2), new XYPos(W * 0.8, 0)] : ((matchValue_13.tag === 0) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos((W * 4) / 5, H), new XYPos(W, H / 2), new XYPos(W * 0.8, 0)] : ((matchValue_13.tag === 1) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos((W * 4) / 5, H), new XYPos(W, H / 2), new XYPos(W * 0.8, 0)] : ((matchValue_13.tag === 50) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos((W * 4) / 5, H), new XYPos(W, H / 2), new XYPos(W * 0.8, 0)] : ((matchValue_13.tag === 51) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos((W * 4) / 5, H), new XYPos(W, H / 2), new XYPos(W * 0.8, 0)] : ((matchValue_13.tag === 52) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos((W * 4) / 5, H), new XYPos(W, H / 2), new XYPos(W * 0.8, 0)] : ((matchValue_13.tag === 53) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos((W * 4) / 5, H), new XYPos(W, H / 2), new XYPos(W * 0.8, 0)] : ((matchValue_13.tag === 7) ? [new XYPos(W, H / 2), new XYPos(W / 2, H / 2), new XYPos(0, H), new XYPos(0, 0), new XYPos(W / 2, H / 2)] : ((matchValue_13.tag === 2) ? [new XYPos(W / 5, 0), new XYPos(0, H / 2), new XYPos(W / 5, H), new XYPos(W, H), new XYPos(W, 0)] : ((matchValue_13.tag === 4) ? [new XYPos(0, H / 2), new XYPos(W / 3, H / 2), new XYPos(W / 3, H - (H / 4)), new XYPos(W / 3, H / 4), new XYPos(W / 3, H / 2)] : ((matchValue_13.tag === 27) ? [new XYPos(0, H / 6), new XYPos(W / 2, H / 6), new XYPos(W / 2, H / 2), new XYPos(W, H / 2), new XYPos(W / 2, H / 2), new XYPos(W / 2, (5 * H) / 6), new XYPos(0, (5 * H) / 6), new XYPos(W / 2, (5 * H) / 6), new XYPos(W / 2, H / 6)] : ((matchValue_13.tag === 28) ? [new XYPos(W, H / 6), new XYPos(W / 2, H / 6), new XYPos(W / 2, H / 2), new XYPos(0, H / 2), new XYPos(W / 2, H / 2), new XYPos(W / 2, (5 * H) / 6), new XYPos(W, (5 * H) / 6), new XYPos(W / 2, (5 * H) / 6), new XYPos(W / 2, H / 6)] : ((matchValue_13.tag === 14) ? [new XYPos(0, 0.3 * W), new XYPos(0, H - (0.3 * W)), new XYPos(W, H), new XYPos(W, 0)] : ((matchValue_13.tag === 15) ? [new XYPos(0, 0.3 * W), new XYPos(0, H - (0.3 * W)), new XYPos(W, H), new XYPos(W, 0)] : ((matchValue_13.tag === 16) ? [new XYPos(0, 0.3 * W), new XYPos(0, H - (0.3 * W)), new XYPos(W, H), new XYPos(W, 0)] : ((matchValue_13.tag === 11) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H - (0.3 * W)), new XYPos(W, 0.3 * W)] : ((matchValue_13.tag === 12) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H - (0.3 * W)), new XYPos(W, 0.3 * W)] : ((matchValue_13.tag === 13) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H - (0.3 * W)), new XYPos(W, 0.3 * W)] : ((matchValue_13.tag === 47) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos(W * 0.6, H), new XYPos(W * 0.8, H * 0.7), new XYPos(W, H * 0.7), new XYPos(W, H * 0.3), new XYPos(W * 0.8, H * 0.3), new XYPos(W * 0.6, 0)] : ((matchValue_13.tag === 5) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos(W * 0.6, H), new XYPos(W * 0.8, H * 0.7), new XYPos(W, H * 0.7), new XYPos(W, H * 0.3), new XYPos(W * 0.8, H * 0.3), new XYPos(W * 0.6, 0)] : ((matchValue_13.tag === 8) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H), new XYPos(W, H / 2), new XYPos(W + 9, H / 2), new XYPos(W, (H / 2) - 8), new XYPos(W, H / 2), new XYPos(W, 0)] : ((matchValue_13.tag === 10) ? (((gateType = matchValue_13.fields[0], (gateType === "nor") ? true : ((gateType === "xnor") ? true : ((gateType === "and") ? false : ((gateType === "or") ? false : (!(gateType === "xor"))))))) ? [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H), new XYPos(W, H / 2), new XYPos(W + 9, H / 2), new XYPos(W, (H / 2) - 8), new XYPos(W, H / 2), new XYPos(W, 0)] : [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H), new XYPos(W, 0)]) : ((matchValue_13.tag === 31) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 32) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 33) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 34) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 40) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 41) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 42) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 35) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 37) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 36) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 38) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : ((matchValue_13.tag === 26) ? ((symbol.IsClocked === true) ? [new XYPos(0, H - 13), new XYPos(8, H - 7), new XYPos(0, H - 1), new XYPos(0, 0), new XYPos(W, 0), new XYPos(W, H), new XYPos(0, H)] : [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H), new XYPos(W, 0)]) : [new XYPos(0, 0), new XYPos(0, H), new XYPos(W, H), new XYPos(W, 0)])))))))))))))))))))))))))))))))))), new XYPos(W / 2, H / 2), transform_1));
    let additions;
    let mergeWiresTextPos;
    const textPoints = rotatePoints([new XYPos(W / 5, (H / 6) + 2), new XYPos(W / 5, ((H * 5) / 6) + 2), new XYPos(W * 0.75, (H / 2) + 2)], new XYPos(W / 2, H / 2), transform_1);
    const matchValue_14 = transform_1.Rotation;
    switch (matchValue_14.tag) {
        case 1:
        case 3: {
            mergeWiresTextPos = map_1((pos_4) => {
                const left_4 = pos_4;
                const right_4 = new XYPos(12, 0);
                return new XYPos(left_4.X + right_4.X, left_4.Y + right_4.Y);
            }, textPoints);
            break;
        }
        case 2: {
            mergeWiresTextPos = map_1((pos_5) => {
                const left_5 = pos_5;
                const right_5 = new XYPos(0, 5);
                return new XYPos(left_5.X + right_5.X, left_5.Y + right_5.Y);
            }, textPoints);
            break;
        }
        default:
            mergeWiresTextPos = textPoints;
    }
    let splitWiresTextPos;
    const textPoints_1 = rotatePoints([new XYPos(W * 0.75, (H / 6) + 2), new XYPos(W * 0.75, ((H * 5) / 6) + 2), new XYPos(W / 4, (H / 2) + 2)], new XYPos(W / 2, H / 2), transform_1);
    const matchValue_15 = transform_1.Rotation;
    switch (matchValue_15.tag) {
        case 1:
        case 3: {
            splitWiresTextPos = map_1((pos_6) => {
                const left_6 = pos_6;
                const right_6 = new XYPos(12, 0);
                return new XYPos(left_6.X + right_6.X, left_6.Y + right_6.Y);
            }, textPoints_1);
            break;
        }
        case 2: {
            splitWiresTextPos = map_1((pos_7) => {
                const left_7 = pos_7;
                const right_7 = new XYPos(0, 5);
                return new XYPos(left_7.X + right_7.X, left_7.Y + right_7.Y);
            }, textPoints_1);
            break;
        }
        default:
            splitWiresTextPos = textPoints_1;
    }
    const inputTextPoints = map_1((port) => getPortPos(symbol, port), toArray(comp.InputPorts));
    const outputTextPoints = map_1((port_1) => getPortPos(symbol, port_1), toArray(comp.OutputPorts));
    const matchValue_17 = comp.Type;
    let matchResult, x_6;
    switch (matchValue_17.tag) {
        case 27: {
            matchResult = 0;
            break;
        }
        case 29: {
            matchResult = 1;
            break;
        }
        case 28: {
            matchResult = 2;
            break;
        }
        case 30: {
            matchResult = 3;
            break;
        }
        case 31:
        case 32:
        case 33:
        case 34:
        case 40:
        case 41:
        case 42:
        case 35:
        case 37:
        case 36:
        case 38: {
            matchResult = 4;
            break;
        }
        case 6: {
            matchResult = 5;
            break;
        }
        case 7: {
            matchResult = 6;
            break;
        }
        case 47: {
            matchResult = 7;
            break;
        }
        case 5: {
            matchResult = 8;
            break;
        }
        case 50:
        case 51:
        case 52:
        case 53: {
            matchResult = 10;
            break;
        }
        case 2: {
            matchResult = 11;
            break;
        }
        case 48: {
            matchResult = 9;
            x_6 = matchValue_17.fields[0];
            break;
        }
        case 0: {
            matchResult = 9;
            x_6 = matchValue_17.fields[0];
            break;
        }
        case 1: {
            matchResult = 9;
            x_6 = matchValue_17.fields[0];
            break;
        }
        default:
            if (symbol.IsClocked) {
                matchResult = 12;
            }
            else {
                matchResult = 13;
            }
    }
    switch (matchResult) {
        case 0: {
            let patternInput_3;
            const matchValue_18 = symbol.InWidth0;
            const matchValue_19 = symbol.InWidth1;
            let matchResult_1, m, n;
            if (matchValue_18 != null) {
                if (matchValue_19 != null) {
                    matchResult_1 = 0;
                    m = matchValue_19;
                    n = matchValue_18;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    patternInput_3 = [n, m];
                    break;
                }
                default:
                    patternInput_3 = [-1, -1];
            }
            const lo = patternInput_3[0] | 0;
            const msb_2 = ((patternInput_3[1] + lo) - 1) | 0;
            const values = ofArray([[lo - 1, 0], [msb_2, lo], [msb_2, 0]]);
            additions = fold_1((og, i) => append(og, mergeSplitLine(item(i, mergeWiresTextPos), item_1(i, values)[0], item_1(i, values)[1])), empty(), toList(rangeDouble(0, 1, 2)));
            break;
        }
        case 1: {
            const matchValue_21 = symbol.InWidths;
            if (matchValue_21 == null) {
                additions = empty();
            }
            else {
                const widths = matchValue_21;
                const matchValue_22 = exists((el) => equals(el, undefined), widths);
                if (matchValue_22) {
                    additions = empty();
                }
                else {
                    const valuesInput = reverse(fold_1((tupledArg, width) => {
                        const lsb_3 = tupledArg[0] | 0;
                        const msb_3 = ((lsb_3 + width) - 1) | 0;
                        return [msb_3 + 1, cons([msb_3, lsb_3], tupledArg[1])];
                    }, [0, empty()], map_2((x_4) => {
                        if (x_4 == null) {
                            return -1;
                        }
                        else {
                            return x_4 | 0;
                        }
                    }, widths))[1]);
                    const valuesOutput = singleton([last(valuesInput)[0], 0]);
                    additions = append(fold2((og_1, pos_9, value) => append(og_1, mergeSplitNLine(comp.Type, PortType.Input, pos_9, value[0], value[1])), empty(), ofArray(inputTextPoints), valuesInput), fold2((og_2, pos_10, value_1) => append(og_2, mergeSplitNLine(comp.Type, PortType.Output, pos_10, value_1[0], value_1[1])), empty(), ofArray(outputTextPoints), valuesOutput));
                }
            }
            break;
        }
        case 2: {
            let patternInput_5;
            const matchValue_23 = symbol.InWidth0;
            patternInput_5 = ((matchValue_23 != null) ? [matchValue_23 - 1, matchValue_17.fields[0]] : [-100, -50]);
            const msb_4 = patternInput_5[0] | 0;
            const mid$0027 = patternInput_5[1] | 0;
            const values_1 = ofArray([[mid$0027 - 1, 0], [msb_4, mid$0027], [msb_4, 0]]);
            additions = fold_1((og_3, i_1) => append(og_3, mergeSplitLine(item(i_1, splitWiresTextPos), item_1(i_1, values_1)[0], item_1(i_1, values_1)[1])), empty(), toList(rangeDouble(0, 1, 2)));
            break;
        }
        case 3: {
            const lsbs = matchValue_17.fields[2];
            const msbs = map2((width_1, lsb_4) => (((lsb_4 + width_1) - 1) | 0), matchValue_17.fields[1], lsbs);
            let inputValue;
            const matchValue_24 = symbol.InWidth0;
            let matchResult_2, width_3;
            if (matchValue_24 != null) {
                if (matchValue_24 > max(msbs, {
                    Compare: (x_5, y_1) => (comparePrimitives(x_5, y_1) | 0),
                })) {
                    matchResult_2 = 0;
                    width_3 = matchValue_24;
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0: {
                    inputValue = [width_3 - 1, 0];
                    break;
                }
                default:
                    inputValue = [-2, -1];
            }
            const outputValues = fold2((acc_1, lsb_5, msb_5) => append(acc_1, singleton([msb_5, lsb_5])), empty(), lsbs, msbs);
            const inputEls_1 = fold2((og_4, pos_11, value_2) => append(og_4, mergeSplitNLine(comp.Type, PortType.Input, pos_11, value_2[0], value_2[1])), empty(), ofArray(inputTextPoints), singleton(inputValue));
            additions = append(fold2((og_5, pos_12, value_3) => append(og_5, mergeSplitNLine(comp.Type, PortType.Output, pos_12, value_3[0], value_3[1])), empty(), ofArray(outputTextPoints), outputValues), inputEls_1);
            break;
        }
        case 4: {
            additions = addText(clockTxtPos, " clk", "middle", "normal", "12px");
            break;
        }
        case 5: {
            let patternInput_2;
            let rotate$0027;
            if (!transform_1.flipped) {
                rotate$0027 = transform_1.Rotation;
            }
            else {
                const matchValue_9 = transform_1.Rotation;
                rotate$0027 = ((matchValue_9.tag === 1) ? Rotation.Degree270 : ((matchValue_9.tag === 3) ? Rotation.Degree90 : matchValue_9));
            }
            patternInput_2 = ((rotate$0027.tag === 2) ? [new XYPos(w / 2, -14), "middle"] : ((rotate$0027.tag === 3) ? [new XYPos(-2, (h / 2) - 7), "end"] : ((rotate$0027.tag === 1) ? [new XYPos(w + 2, (h / 2) - 7), "start"] : [new XYPos(w / 2, h + 2), "middle"])));
            additions = addText(patternInput_2[0], busSelectTitle(matchValue_17.fields[0], matchValue_17.fields[1]), patternInput_2[1], "bold", Constants_busSelectTextSize);
            break;
        }
        case 6: {
            const dialogVal = matchValue_17.fields[2];
            let patternInput_6;
            const matchValue_26 = transform_1.Rotation;
            let matchResult_3;
            if (transform_1.flipped) {
                switch (matchValue_26.tag) {
                    case 0: {
                        matchResult_3 = 0;
                        break;
                    }
                    case 1: {
                        matchResult_3 = 1;
                        break;
                    }
                    case 3: {
                        matchResult_3 = 2;
                        break;
                    }
                    default:
                        matchResult_3 = 3;
                }
            }
            else {
                switch (matchValue_26.tag) {
                    case 2: {
                        matchResult_3 = 0;
                        break;
                    }
                    case 1: {
                        matchResult_3 = 1;
                        break;
                    }
                    case 3: {
                        matchResult_3 = 2;
                        break;
                    }
                    default:
                        matchResult_3 = 3;
                }
            }
            switch (matchResult_3) {
                case 0: {
                    patternInput_6 = ["end", 0, 5];
                    break;
                }
                case 1: {
                    patternInput_6 = ["end", -15, -5];
                    break;
                }
                case 2: {
                    patternInput_6 = ["end", 0, -5];
                    break;
                }
                default:
                    patternInput_6 = ["start", 0, -5];
            }
            additions = addText(new XYPos((w / 2) + patternInput_6[2], (h / 1.5) + patternInput_6[1]), dialogVal, patternInput_6[0], "normal", (dialogVal.length < 2) ? "14px" : "12px");
            break;
        }
        case 7: {
            additions = addText(new XYPos((w / 2) - 2, (h / 2.7) - 1), "=" + fillHexBignum(matchValue_17.fields[0], matchValue_17.fields[1]), "middle", "bold", "10px");
            break;
        }
        case 8: {
            additions = addText(new XYPos((w / 2) - 2, (h / 2.7) - 1), "= " + matchValue_17.fields[2], "middle", "bold", "10px");
            break;
        }
        case 9: {
            additions = addText(new XYPos(w / 2, h / 2.7), busTitleAndBits("", x_6), "middle", "normal", "12px");
            break;
        }
        case 10: {
            additions = empty();
            break;
        }
        case 11: {
            additions = addText(new XYPos(w / 2, (h / 2.7) - 1.25), busTitleAndBits("", matchValue_17.fields[0]), "middle", "normal", "9px");
            break;
        }
        case 12: {
            additions = addText(head(rotatePoints([new XYPos(15, H - 11)], new XYPos(W / 2, H / 2), transform_1)), " clk", "middle", "normal", "12px");
            break;
        }
        default:
            additions = empty();
    }
    let patternInput_7;
    const matchValue_28 = comp.Type;
    switch (matchValue_28.tag) {
        case 28:
        case 27: {
            patternInput_7 = [outlineColor(colour), "4.0"];
            break;
        }
        case 4: {
            patternInput_7 = [outlineColor(colour), "4.0"];
            break;
        }
        default:
            patternInput_7 = ["black", "1.0"];
    }
    const labelcolour = outlineColor(symbol.Appearance.Colour);
    const isArrayIO = (ct) => {
        switch (ct.tag) {
            case 50:
            case 51:
            case 52:
            case 53:
                return true;
            default:
                return false;
        }
    };
    const legendFontSize = (ct_1) => {
        if (ct_1.tag === 26) {
            return Constants_customLegendFontSizeInPixels;
        }
        else if (isArrayIO(ct_1)) {
            return Constants_arrayLegendFontSizeInPixels;
        }
        else {
            return Constants_otherLegendFontSizeInPixels;
        }
    };
    let list_19;
    const list_17 = append(additions, (list_14 = ((list_12 = ((list_10 = ((list_8 = ((list_4 = drawPorts(PortType.Output, comp.OutputPorts, showPorts, symbol), append(drawPorts(PortType.Input, comp.InputPorts, showPorts, symbol), list_4))), append(drawPortsText(append(comp.InputPorts, comp.OutputPorts), (tupledArg_1 = portNames(comp.Type), append(tupledArg_1[0], tupledArg_1[1])), symbol), list_8))), append(drawCorners(appear.ShowCorners, symbol), list_10))), append(addLegendText((compWidth = w, (symbol_1 = symbol, (vertFlip = equals(symbol_1.STransform.Rotation, Rotation.Degree180), (getNum = ((edge) => {
        let option_1;
        return defaultArg((option_1 = tryFind(edge, symbol_1.PortMaps.Order), (option_1 != null) ? length(option_1) : undefined), 0) | 0;
    }), (offset = ((matchValue_39 = ((getNum(Edge.Left) % 2) | 0), (matchValue_40 = ((getNum(Edge.Right) % 2) | 0), (matchValue_41 = symbol_1.Component.Type, (matchValue_41.tag === 50) ? (new XYPos(0, 0)) : ((matchValue_41.tag === 51) ? (new XYPos(0, 0)) : ((matchValue_41.tag === 52) ? (new XYPos(0, 0)) : ((matchValue_41.tag === 53) ? (new XYPos(0, 0)) : ((matchValue_41.tag === 26) ? ((matchValue_39 === 0) ? ((matchValue_40 === 0) ? (new XYPos(0, 0)) : ((matchValue_40 === 1) ? (new XYPos(-10, 0)) : (new XYPos(0, 0)))) : ((matchValue_39 === 1) ? ((matchValue_40 === 0) ? (new XYPos(10, 0)) : ((matchValue_40 === 1) ? (new XYPos(0, 0)) : (new XYPos(0, 0)))) : (new XYPos(0, 0)))) : ((matchValue_41.tag === 29) ? (new XYPos(0, (Constants_legendVertOffset * 1.1) * -3)) : ((matchValue_41.tag === 30) ? ((matchValue_40 === 0) ? (($007CIsBinaryGate$007CNotBinaryGate$007C(matchValue_41).tag === 0) ? (new XYPos(0, 0)) : ((matchValue_39 === 0) ? (new XYPos(0, 0)) : ((matchValue_39 === 1) ? (new XYPos(10, 0)) : toFail(printf("What? Can\'t happen"))))) : ((matchValue_40 === 1) ? (new XYPos(0, (Constants_legendVertOffset * 1.1) * -3)) : (($007CIsBinaryGate$007CNotBinaryGate$007C(matchValue_41).tag === 0) ? (new XYPos(0, 0)) : toFail(printf("What? Can\'t happen"))))) : ((matchValue_41.tag === 46) ? (new XYPos(0, Constants_legendVertOffset * (vertFlip ? 0.5 : -3))) : ((matchValue_41.tag === 8) ? (new XYPos(0, 0)) : (($007CIsBinaryGate$007CNotBinaryGate$007C(matchValue_41).tag === 0) ? (new XYPos(0, 0)) : ((matchValue_39 === 0) ? ((matchValue_40 === 0) ? (new XYPos(0, 0)) : ((matchValue_40 === 1) ? (new XYPos(-10, 0)) : toFail(printf("What? Can\'t happen")))) : ((matchValue_39 === 1) ? ((matchValue_40 === 0) ? (new XYPos(10, 0)) : ((matchValue_40 === 1) ? (new XYPos(0, Constants_legendVertOffset * (vertFlip ? 0.5 : -3))) : toFail(printf("What? Can\'t happen")))) : toFail(printf("What? Can\'t happen"))))))))))))))))), (chevronShift = ((matchValue_43 = symbol_1.Component.Type, (matchValue_43.tag === 48) ? (new XYPos(-compWidth * 0.1, 0)) : ((matchValue_43.tag === 0) ? (new XYPos(-compWidth * 0.1, 0)) : ((matchValue_43.tag === 1) ? (new XYPos(-compWidth * 0.1, 0)) : ((matchValue_43.tag === 50) ? (new XYPos(-compWidth * 0.1, 0)) : ((matchValue_43.tag === 51) ? (new XYPos(-compWidth * 0.1, 0)) : ((matchValue_43.tag === 52) ? (new XYPos(-compWidth * 0.1, 0)) : ((matchValue_43.tag === 53) ? (new XYPos(-compWidth * 0.1, 0)) : (new XYPos(0, 0)))))))))), (left_17 = ((left_16 = (new XYPos(compWidth / 2, (h / 2) - (isArrayIO(symbol_1.Component.Type) ? (legendFontSize(symbol_1.Component.Type) / 2) : 7))), (right_16 = offset, new XYPos(left_16.X + right_16.X, left_16.Y + right_16.Y)))), (right_17 = chevronShift, new XYPos(left_17.X + right_17.X, left_17.Y + right_17.Y))))))))), getComponentLegend(symbol.ArrayText, comp.Type, transform_1.Rotation), "middle", isArrayIO(comp.Type) ? "normal" : "bold", `${legendFontSize(comp.Type)}px`), list_12))), append((comp_2 = comp, (box = symbol.LabelBoundingBox, (margin = ((matchValue_29 = comp_2.Type, (matchValue_29.tag === 6) ? Constants_thinComponentLabelOffsetDistance : ((matchValue_29.tag === 3) ? Constants_thinComponentLabelOffsetDistance : Constants_componentLabelOffsetDistance))), (pos_13 = ((left_10 = ((left_9 = ((left_8 = box.TopLeft, (right_8 = symbol.Pos, new XYPos(left_8.X - right_8.X, left_8.Y - right_8.Y)))), (right_9 = (new XYPos(margin, margin)), new XYPos(left_9.X + right_9.X, left_9.Y + right_9.Y)))), new XYPos(left_10.X + Constants_labelCorrection.X, left_10.Y + Constants_labelCorrection.Y))), (text_2 = addStyledText(pos_13, new Text$(Constants_componentLabelStyle.TextAnchor, Constants_componentLabelStyle.FontSize, Constants_componentLabelStyle.FontWeight, Constants_componentLabelStyle.FontFamily, Constants_componentLabelStyle.Fill, Constants_componentLabelStyle.UserSelect, "hanging"), (matchValue_31 = symbol.ArrayText, (comp_2.Type.tag === 1) ? ((matchValue_31 != null) ? ((loop = matchValue_31, concat(comp_2.Label, ".", loop))) : comp_2.Label) : comp_2.Label)), Constants_testShowLabelBoundingBoxes ? ((dimW = (new XYPos(box.W, 0)), (dimH = (new XYPos(0, box.H)), cons(text_2, map_2((c) => {
        let c$0027;
        const left_15 = c;
        const right_15 = symbol.Pos;
        c$0027 = (new XYPos(left_15.X - right_15.X, left_15.Y - right_15.Y));
        return makeCircle(c$0027.X, c$0027.Y, new Circle(3, defaultCircle.Stroke, defaultCircle.StrokeWidth, defaultCircle.FillOpacity, defaultCircle.Fill));
    }, ofArray([box.TopLeft, (left_11 = box.TopLeft, (right_11 = dimW, new XYPos(left_11.X + right_11.X, left_11.Y + right_11.Y))), (left_12 = box.TopLeft, (right_12 = dimH, new XYPos(left_12.X + right_12.X, left_12.Y + right_12.Y))), (left_14 = ((left_13 = box.TopLeft, (right_13 = dimW, new XYPos(left_13.X + right_13.X, left_13.Y + right_13.Y)))), (right_14 = dimH, new XYPos(left_14.X + right_14.X, left_14.Y + right_14.Y)))])))))) : ((labelcolour === "lightgreen") ? ((comp_2.Label !== "") ? ((y_3 = (pos_13.Y - (margin * 0.8)), (x_8 = (pos_13.X - (margin * 0.8)), (w_1 = (box.W - (margin * 0.4)), (h_1 = (box.H - (margin * 0.4)), ofArray([makePolygon(`${x_8},${y_3} ${x_8 + w_1},${y_3} ${x_8 + w_1},${y_3 + h_1} ${x_8},${y_3 + h_1}`, new Polygon(defaultPolygon.Stroke, "0", defaultPolygon.FillOpacity, "lightgreen")), text_2])))))) : singleton(text_2)) : singleton(text_2))))))), list_14)));
    list_19 = append(drawMovingPortTarget(symbol.MovingPortTarget, symbol, points), list_17);
    return append(createBiColorPolygon(points, colour, patternInput_7[0], appear.Opacity, patternInput_7[1], comp), list_19);
}

class RenderSymbolProps extends Record {
    constructor(Symbol$, Dispatch, key, Theme) {
        super();
        this.Symbol = Symbol$;
        this.Dispatch = Dispatch;
        this.key = key;
        this.Theme = Theme;
    }
}

function RenderSymbolProps_$reflection() {
    return record_type("SymbolView.RenderSymbolProps", [], RenderSymbolProps, () => [["Symbol", DrawModelType_SymbolT_Symbol_$reflection()], ["Dispatch", lambda_type(DrawModelType_SymbolT_Msg_$reflection(), unit_type)], ["key", string_type], ["Theme", DrawModelType_SymbolT_ThemeType_$reflection()]]);
}

const renderSymbol = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_5("D:\\a\\issie-web\\issie-web\\src\\Renderer\\DrawBlock\\SymbolView.fs") + "#L") + int32ToString(value_5(627))) + ";") + "SymbolView.RenderSymbolProps", "Symbol", (props) => {
    const patternInput = props.Symbol.Pos;
    const props_1 = [["style", {
        transform: toText(`translate(${patternInput.X}px, ${patternInput.Y}px)`),
    }]];
    const children = drawComponent(props.Symbol, props.Theme);
    return react.createElement("g", keyValueList(props_1, 1), ...children);
}, Helpers_equalsButFunctions, undefined, "Of");

/**
 * `highlighted` are the symbols to show picked out for a reason outside the draw block - see
 * DrawModelType.Highlighted. The colour is applied to the symbol VALUE the renderer is given, not
 * to the model: the props are what React memoises on, so a symbol whose highlight changes redraws
 * and one whose does not is left alone, exactly as for any other change to it.
 */
export function view(model, highlighted, dispatch) {
    let map;
    return toArray(map_2((symbol) => {
        const symbol_1 = symbol;
        return renderSymbol(new RenderSymbolProps(contains(symbol_1.Id, highlighted) ? Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_))(DrawModelType_HighlightedModule_compColour)(symbol_1) : symbol_1, dispatch, int32ToString(symbol_1.Id), model.Theme));
    }, (map = model.Symbols, append(map_2((tuple) => tuple[1], toList_1(filter((_arg, sym) => (!sym.Moving && equals(sym.Annotation, undefined)), map))), map_2((tuple_1) => tuple_1[1], toList_1(filter((_arg_1, sym_1) => (sym_1.Moving && equals(sym_1.Annotation, undefined)), map)))))));
}

/**
 * init function for initial Symbol Model
 */
export function init() {
    return [new DrawModelType_SymbolT_Model(empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), empty_1({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }), empty_1({
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    }), empty_2({
        Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
    }), empty_1({
        Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
    }), DrawModelType_SymbolT_ThemeType.Colourful, undefined), Cmd_none()];
}

